const NotFound = () => {
    return (
        <div className="not-found">
            <h2>Sorry!</h2>
            <p>The page does not exist!</p>
        </div>
    )
}

export default NotFound;